
import {
    IUpdateNbnTestResultAction,
    IUpdateDiagnosticResultAction,
    IAddToastAction,
    IAddResultToastAction,
    IDismissResultToastAction,
    IAddErrorToastAction,
    IDeleteErrorToastAction,
    IUpdateNbnTestErrorAction
} from '../actions/update-nbn-test-result';
import { IServiceRequestsState } from '../state';
import { IToast } from '../state/nbn-services-list';

export type UpdateNbnTestResultAction = IUpdateNbnTestResultAction;
export type UpdateDiagnosticResultAction = IUpdateDiagnosticResultAction;
export type UpdateDiagnosticErrorAction = IUpdateNbnTestErrorAction;
export type AddToastAction = IAddToastAction;
export type AddErrorToastAction = IAddErrorToastAction;
export type DeleteErrorToastAction = IDeleteErrorToastAction;
export type AddResultToastAction = IAddResultToastAction;
export type DismissResultToastAction = IDismissResultToastAction;
export const updateNbnTestMessageReducer = (state: IServiceRequestsState, action: IUpdateNbnTestResultAction) => {
    const index = [];
    action.data.services.map((item1) => {
        index.push(state.nbnServiceListDetails.data.nbnServices.map((item) =>
            item.serviceNumber).indexOf(item1.serviceId));
    });

    const services = state.nbnServiceListDetails.data.nbnServices;
    index.map((item3) => {
        services[item3] = {
            ...services[item3],
            testResults: action.data.diagnosticTestMessage,
            diagnosticStatus: action.data.diagnosticStatus,
            testPosition: state.nbnServiceListDetails.data.testCounter++
        }
    })
    services.sort((prev, next) => next.testPosition - prev.testPosition);
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                nbnServices: services
            }
        }
    };
}

export const updateNbnResultMessageReducer = (state: IServiceRequestsState, action: IUpdateNbnTestResultAction) => {
    const index = [];
    action.data.services.map((item1) => {
        index.push(state.nbnServiceListDetails.data.nbnServices.map((item) =>
            item.serviceNumber).indexOf(item1.serviceId));
    });

    const services = state.nbnServiceListDetails.data.nbnServices;
    index.map((item3) => {
        const ind = action.data.services.map((item) => item.serviceId).indexOf(services[item3].serviceNumber);
        services[item3] = {
            ...services[item3],
            testResults: action.data.services[ind].diagnosticResultMessage,
            diagnosticStatus: action.data.diagnosticStatus,
            testPosition: state.nbnServiceListDetails.data.testCounter++
        }
    })
    services.sort((prev, next) => next.testPosition - prev.testPosition);
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                nbnServices: services
            }
        }
    };
}

export const updateNbnDiagnosticResultReducer = (state: IServiceRequestsState,
    action: IUpdateDiagnosticResultAction) => {
    const index = [];
    action.data.services.map((item1) => {
        index.push(state.nbnServiceListDetails.data.nbnServices.map((item) =>
            item.serviceNumber).indexOf(item1.serviceId));
    });
    const services = state.nbnServiceListDetails.data.nbnServices;
    index.map((item3) => {
        const ind = action.data.services.map((item) => item.serviceId).indexOf(services[item3].serviceNumber);
        services[item3] = {
            ...services[item3],
            diagnosticResult: action.data.services[ind].diagnosticResult,
            diagnosticName: action.diagnosticName
        }
    });
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                nbnServices: services
            }
        }
    };
}

export const updateNbnErrorMessageReducer = (state: IServiceRequestsState,
    action: UpdateDiagnosticErrorAction) => {
    const index = [];
    action.services.map((item1) => {
        index.push(state.nbnServiceListDetails.data.nbnServices.map((item) =>
            item.serviceNumber).indexOf(item1.serviceId));
    });
    const services = state.nbnServiceListDetails.data.nbnServices;
    index.map((item3) => {
        services[item3] = {
            ...services[item3],
            testResults: '',
            diagnosticResult: action.result,
            diagnosticStatus: action.status,
            testPosition: state.nbnServiceListDetails.data.testCounter++
        }
    });
    services.sort((prev, next) => next.testPosition - prev.testPosition);
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                nbnServices: services
            }
        }
    };
}

export const addToastReducer = (state: IServiceRequestsState,
    action: IAddToastAction) => {
    let toastData: IToast[] = [];
    if (state.nbnServiceListDetails.data.toast) {
        toastData = state.nbnServiceListDetails.data.toast.data
    }

    const toast: IToast = action.test.services.length === 1 ?
        {
            serviceId: action.test.services[0].serviceId,
            diagnosticName: action.test.diagnosticName,
            diagnosticStatus: action.test.diagnosticStatus
        } : {
            noOfServices: action.test.services.length,
            serviceId: action.test.services[0].serviceId,
            diagnosticName: action.test.diagnosticName,
            diagnosticStatus: action.test.diagnosticStatus
        };
    toastData.push(toast);
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                toast: {
                    data: [...toastData],
                    toastTagFlag: true
                }
            }
        }
    };
}

export const deleteToastReducer = (state: IServiceRequestsState,
    action: IAddToastAction) => {
    let toastData: IToast[] = [];
    if (state.nbnServiceListDetails.data.toast) {
        toastData = state.nbnServiceListDetails.data.toast.data
    }
    const index = toastData.map((item) => item.serviceId).indexOf(action.test.services[0].serviceId);
    toastData.splice(index, 1);
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                toast: {
                    data: [...toastData],
                    toastTagFlag: false
                }
            }
        }
    };
}

export const addResultToastReducer = (state: IServiceRequestsState,
    action: IAddResultToastAction) => {
    let toastData: IToast[] = [];
    let toastCount = 0;
    if (state.nbnServiceListDetails.data.toast) {
        toastData = state.nbnServiceListDetails.data.toast.data
    }

    const success = (action.result.services.filter((item) => item.diagnosticResult === 'Pass'));
    const fail = (action.result.services.filter((item) => item.diagnosticResult === 'Fail'));
    const incomplete = (action.result.services.filter((item) =>
        item.diagnosticResult === 'Inconclusive' || item.diagnosticResult === 'Timeout'));

    if (action.result.services.length === 1) {
        toastData.push(
            {
                serviceId: action.result.services[0].serviceId,
                diagnosticName: action.result.diagnosticName,
                diagnosticResult: action.result.services[0].diagnosticResult
            }
        )
    };

    if (success.length > 0 && action.result.services.length > 1) {
        toastCount++;
        toastData.push(
            {
                noOfServices: success.length,
                serviceId: success.length === 1 ? success[0].serviceId : action.result.services[0].serviceId,
                diagnosticName: action.result.diagnosticName,
                diagnosticResult: success[0].diagnosticResult
            }
        )
    }
    if (fail.length > 0 && action.result.services.length > 1) {
        toastCount++;
        toastData.push(
            {
                noOfServices: fail.length,
                serviceId: fail.length === 1 ? fail[0].serviceId : action.result.services[0].serviceId,
                diagnosticName: action.result.diagnosticName,
                diagnosticResult: fail[0].diagnosticResult
            }
        )
    }
    if (incomplete.length > 0 && action.result.services.length > 1) {
        toastCount++;
        toastData.push(
            {
                noOfServices: incomplete.length,
                serviceId: incomplete.length === 1 ? incomplete[0].serviceId : action.result.services[0].serviceId,
                diagnosticName: action.result.diagnosticName,
                diagnosticResult: incomplete[0].diagnosticResult
            }
        )
    }
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                toast: {
                    data: [...toastData],
                    toastTagFlag: true,
                    toastCount
                }
            }
        }
    };
}

export const deleteResultToastReducer = (state: IServiceRequestsState,
    action: IAddResultToastAction) => {
    let toastData: IToast[] = [];
    if (state.nbnServiceListDetails.data.toast) {
        toastData = state.nbnServiceListDetails.data.toast.data
    }
    const index1 = [];
    toastData.map((item, index) => {
        if (action.result.services.filter((item1) => item.serviceId === item1.serviceId)) {
            index1.push(index)
        }
    });
    while (index1.length) {
        (toastData.splice(index1.pop(), 1))
    }

    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                toast: {
                    data: [...toastData],
                    toastTagFlag: false
                }
            }
        }
    };
}

export const dismissToastReducer = (state: IServiceRequestsState,
    action: IDismissResultToastAction) => {
    let toastData: IToast[] = [];
    if (state.nbnServiceListDetails.data.toast) {
        toastData = state.nbnServiceListDetails.data.toast.data
    }
    let index1;
    toastData.map((item, index) => {
        if (item.serviceId === action.serviceId && item.diagnosticResult === action.diagnosticResult) {
            index1 = index
        }
    })
    toastData.splice(index1, 1);
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 1,
                toast: {
                    data: [...toastData],
                    toastTagFlag: false
                }
            }
        }
    };
}

export const addErrorToastReducer = (state: IServiceRequestsState,
    action: IAddErrorToastAction) => {
    let toastData: IToast[] = [];
    if (state.nbnServiceListDetails.data.toast) {
        toastData = state.nbnServiceListDetails.data.toast.data
    }
    const toast: IToast = action.services.length > 1 ?
        {
            noOfServices: action.services.length,
            serviceId: action.services[0].serviceId,
            diagnosticName: action.diagnosticName,
            diagnosticResult: action.status
        } :
        {
            serviceId: action.services[0].serviceId,
            diagnosticName: action.diagnosticName,
            diagnosticResult: action.status
        }
    toastData.push(toast);
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                toast: {
                    data: [...toastData],
                    toastTagFlag: true
                }
            }
        }
    };
}

export const deleteErrorToastReducer = (state: IServiceRequestsState,
    action: IDeleteErrorToastAction) => {
    let toastData: IToast[] = [];
    if (state.nbnServiceListDetails.data.toast) {
        toastData = state.nbnServiceListDetails.data.toast.data
    }
    const index = toastData.map((item) => item.serviceId).indexOf(action.services[0].serviceId)
    toastData.splice(index, 1);
    return {
        ...state,
        nbnServiceListDetails: {
            ...state.nbnServiceListDetails,
            data: {
                ...state.nbnServiceListDetails.data,
                currentPage: 0,
                toast: {
                    data: [...toastData],
                    toastTagFlag: false
                }
            }
        }
    };
}
